import { getCookiesValue } from 'helpers/cookie'

const avatarCache = new Map()

export const loadAvatarCached = async (src) => {
  if (!src) return null

  const existing = avatarCache.get(src)

  if (existing?.objectUrl) {
    return existing.objectUrl
  }

  if (existing?.promise) {
    return existing.promise
  }

  const token = getCookiesValue('ac_token')

  const promise = fetch(src, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        avatarCache.delete(src)
        return null
      }

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)

      avatarCache.set(src, {
        objectUrl,
      })

      return objectUrl
    })
    .catch(() => {
      avatarCache.delete(src)
      return null
    })

  avatarCache.set(src, { promise })

  return promise
}
